// extracted by mini-css-extract-plugin
export var root = "favorites-module--root--ZJR8M";
export var favoriteListContainer = "favorites-module--favoriteListContainer--c9EpE";
export var confirmDeleteContainer = "favorites-module--confirmDeleteContainer--T-KdG";
export var actionContainer = "favorites-module--actionContainer--N1X-p";
export var addressListContainer = "favorites-module--addressListContainer--wR8Ei";